import React, { useContext, useMemo } from 'react';
import { Container, Grid, Hidden, Link, Paper, Typography } from '@material-ui/core';
import Header from '../../components/Header';
import BackgroundImage from '../../components/BackgroundImage';
import { PaymentInfoContext, PaymentMode } from '../../App';
import OrderItems from '../../components/OrderItems';
import logo from '../../assets/images/iol-logo.svg';
import { format, eachDayOfInterval } from 'date-fns';
import useStyles from './styles';
import { useTranslation } from 'react-i18next';
import { enUS, zhCN, ar, arSA, ru, es, fr, it, de, ja } from 'date-fns/locale';
import i18next from 'i18next';
import { selectedLanguage, DateFormat } from '../../utils/index';
import { PaymentModes } from '../../utils';

const locales = { enUS, zhCN, ar, arSA, ru, es, fr, it, de, ja };
const CheckoutLayout = ({ children }) => {
  const DATE_FORMAT = DateFormat(i18next.language);
  const classes = useStyles();
  const paymentInfo = useContext(PaymentInfoContext);
  const paymentMode = useContext(PaymentMode);
  const { t } = useTranslation();
  let lng = selectedLanguage(i18next.language);
  const locale = locales[lng];
  // console.log(lng + 'lng');
  // console.log(locale + 'local');
  const checkInDate = useMemo(() => {
    const checkIn = paymentInfo?.hotelDetails?.checkInDate && new Date(paymentInfo?.hotelDetails?.checkInDate);
    if (!checkIn) return null;
    return format(checkIn, DATE_FORMAT, { locale });
  }, [paymentInfo?.hotelDetails]);

  const checkOutDate = useMemo(() => {
    const checkOut = paymentInfo?.hotelDetails?.checkOutDate && new Date(paymentInfo?.hotelDetails?.checkOutDate);
    if (!checkOut) return null;
    return format(checkOut, DATE_FORMAT, { locale });
  }, [paymentInfo?.hotelDetails?.checkOutDate]);

  const getDate = useMemo(() => {
    if (
      !paymentInfo?.hotelDetails?.checkInDate ||
      !paymentInfo?.hotelDetails?.checkOutDate ||
      new Date(paymentInfo?.hotelDetails?.checkInDate).valueOf() >=
        new Date(paymentInfo?.hotelDetails?.checkOutDate).valueOf()
    )
      return 0;
    return (
      eachDayOfInterval({
        start: new Date(paymentInfo?.hotelDetails?.checkInDate),
        end: new Date(paymentInfo?.hotelDetails?.checkOutDate)
      })?.length - 1
    );
  }, [paymentInfo?.hotelDetails?.checkInDate, paymentInfo?.hotelDetails?.checkOutDate]);

  return (
    <Container maxWidth="md" disableGutters>
      <Paper elevation={3}>
        <Grid container className="chktp_fsltn_msect" spacing={0}>
          <Hidden smDown>
            <Grid item xs={6}>
              <div className={classes.paymentInfo}>
                <div className={classes.topBlock}>
                  <div className={classes.backNav}>
                    <Typography onClick={() => history.back()} variant="body2">
                      <i className={classes.icon} />
                      <span className={`${classes.link} back_link`}>{t('Back')}</span>
                    </Typography>
                  </div>
                  <div className={classes.logo}>
                    <img src={paymentInfo?.companyLogo} alt="logo" className={classes.logoImg} />
                  </div>
                  {checkOutDate != null && getDate > 0 && (
                    <div className={`${classes.date} product_details`}>
                      {t(checkInDate)} {t('to')} {t(checkOutDate)} ({t(getDate)} {t('nights')})
                    </div>
                  )}
                  <BackgroundImage src={paymentInfo?.companyStyle?.backgroundPicture || ''} />
                  <OrderItems
                    orderItems={paymentInfo?.lineItems}
                    amount={paymentInfo?.amount}
                    currency={paymentInfo?.currency}
                  />
                </div>
                <div className={classes.bottomBlock}>
                  <div className={classes.logoLink}>
                    {t('Powered_by')}{' '}
                    <Link href="#">
                      <img src={logo} alt="logo" className={classes.logoBottom} />
                    </Link>
                  </div>
                  <Link href="#" className={`${classes.policyLink} policy_text`}>
                    {t('Privacy_Policy')}
                  </Link>
                </div>
              </div>
            </Grid>
          </Hidden>

          <Grid item xs={12} sm={12} md={6}>
            <div className={`${classes.paymentCheckout} product_text`}>
              {paymentMode !== PaymentModes.Token && (
                <Header amount={paymentInfo?.amount} currency={paymentInfo?.currency} />
              )}
              {children}
            </div>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default CheckoutLayout;
